module.exports = __webpack_public_path__ + "static/media/svg.617b5f96.png";